import { sessionUtils } from "@/lib/session-utils";
import api, { API_ENDPOINTS } from "@/src/api/api";
import { config } from "@/src/config/config";
import { AxiosRequestConfig } from "axios";

interface IScanPassword {
file:File
type:string
}
//  const BASE_URL_LG = "http://192.168.0.18:8009";
const BASE_URL_LG = config.API_URL + "/leakguard_service";

export const LeakGuardService = {

 
  scanPassword: async (
    payload: IScanPassword,
    config: AxiosRequestConfig = {},
    shouldThrowError: boolean = false
  ) => {
    try {
      const {file ,type}= payload
      const conf = {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${sessionUtils.getToken()}`, 
          "Content-Type": "multipart/form-data" 
        }
      };

      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", type);

      const response = await api.post(
        `${BASE_URL_LG}${API_ENDPOINTS.SCAN_PASSWORD}`,
        formData,
        conf
      );
      return response;
    } catch (error) {
      if (shouldThrowError) {
        throw error;
      }
    }
  },
LeakguardScanHistory: async (page: number = 1, pageSize: number = 10, search?: string) => {
  try {
    const conf = {
      headers: {
        Authorization: `Bearer ${sessionUtils.getToken()}`,
      },
      params: {
        page: page,
        page_size: pageSize,
        search,
      },
    };
    const response = await api.get(
      `${BASE_URL_LG}${API_ENDPOINTS.LEAKGUARD_SCAN_HISTORY}`, 
      conf
    );
    return response.data;
  } catch (error) {
    throw error;
  }
},
Dehased: async (
  formData: FormData,
  config: AxiosRequestConfig = {},
  shouldThrowError: boolean = false
) => {
  try {
    const conf = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${sessionUtils.getToken()}`, 
        "Content-Type": "multipart/form-data" 
      }
    };

    const response = await api.post(
      `${BASE_URL_LG}${API_ENDPOINTS.SCAN_PASSWORD}`,
      formData,
      conf
    );
    return response.data;
  } catch (error) {
    if (shouldThrowError) {
      throw error;
    }
  }
},
TextHIBP: async (
  formData: FormData,
  config: AxiosRequestConfig = {},
  shouldThrowError: boolean = false
) => {
  try {
    const conf = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${sessionUtils.getToken()}`, 
        "Content-Type": "multipart/form-data" 
      }
    };

    const response = await api.post(
      `${BASE_URL_LG}${API_ENDPOINTS.TEXT_HIBP}`,
      formData,
      conf
    );
    
    return response;
   
  } catch (error) {
    if (shouldThrowError) {
      throw error;
    }
  }
},
TextDehased: async (
  formData: FormData,
  config: AxiosRequestConfig = {},
  shouldThrowError: boolean = false
) => {
  try {
    const conf = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${sessionUtils.getToken()}`, 
        "Content-Type": "multipart/form-data" 
      }
    };

    const response = await api.post(
      `${BASE_URL_LG}${API_ENDPOINTS.TEXT_DEHASED}`,
      formData,
      conf
    );
    
    return response.data;
   
  } catch (error) {
    if (shouldThrowError) {
      throw error;
    }
  }
},

AddNewMonitor: async (payload: any) => {
    try {
      const conf = {
        headers: {
          Authorization: `Bearer ${sessionUtils.getToken()}`,
        },
      };
      const response = await api.post(
        `${BASE_URL_LG}${API_ENDPOINTS.ADD_NEW_MONITOR}`,
        payload,
        conf
      );
      return response.data;
    } catch (error) {
      throw error;
    }
},

UpdateMonitor: async (id: string, payload: any) => {
  try {
    const conf = {
      headers: {
        Authorization: `Bearer ${sessionUtils.getToken()}`,
      },
    };
    const response = await api.put(
      `${BASE_URL_LG}${API_ENDPOINTS.UPDATE_MONITOR}/${id}`,
      payload,
      conf
    );
    return response.data;
  } catch (error) {
    throw error;
  }
},

GetAllMonitors: async (
  page: number = 1, 
  pageSize: number = 10,
  type?: string,
  status?: string,
  search?: string
) => {
  try {
    const params: any = {
      page: page,
      page_size: pageSize,
    };

    // Only add filters if they are provided (not "all")
    if (type) {
      params.filter_type = type;
    }
    
    if (status) {
      params.filter_task_status = status;
    }
    
    if (search) {
      params.filter_value = search;
    }

    const conf = {
      headers: {
        Authorization: `Bearer ${sessionUtils.getToken()}`,
      },
      params: params,
    };

    const response = await api.get(
      `${BASE_URL_LG}${API_ENDPOINTS.GET_ALL_MONITORS}`,
      conf
    );
    return response.data;
  } catch (error) {
    throw error;
  }
},

UpdateMonitorStatus: async (monitorId: string, status: string) => {
  try {
    const conf = {
      headers: {
        Authorization: `Bearer ${sessionUtils.getToken()}`,
      },
    };
    const response = await api.put(
      `${BASE_URL_LG}${API_ENDPOINTS.UPDATE_MONITOR_STATUS}/${monitorId}?status=${status}`,
      { status },
      conf
    );
    return response.data;
  } catch (error) {
    throw error;
  }
},

DeleteMonitor: async (monitorId: string) => {
  try {
    const conf = {
      headers: {
        Authorization: `Bearer ${sessionUtils.getToken()}`,
      },
    };
    const response = await api.delete(
      `${BASE_URL_LG}${API_ENDPOINTS.DELETE_MONITOR}/${monitorId}`,
      conf
    );
    return response.data;
  } catch (error) {
    throw error;
  }
},
} 
